module.exports = __webpack_public_path__ + "static/spectre-d5608ada9b09b6d9e4b7c845c0effc88.mp4";